export type FormatWithNumberSeparatorsOptions = {
  format: string;
  previousValue?: string;
  value: string;
};
export function formatNumberString({
  format,
  previousValue,
  value,
}: FormatWithNumberSeparatorsOptions): string | undefined {
  const userIsBackspacing = previousValue ? previousValue?.length > value.length : false;

  if (userIsBackspacing) {
    return value;
  }

  const separatorRegex = /[^x\d]+/g;
  const separators: string[] = [];
  let match;
  while ((match = separatorRegex.exec(format)) !== null) {
    separators.push(match[0]);
  }

  let updatedString = value.replaceAll(Array.from(new Set(separators)).join(''), '');

  for (let i = 0; i < updatedString.length; i++) {
    const currentValue = updatedString.charAt(i);
    const currentFormatValue = format.charAt(i);
    const currentSeparator = separators.find((s) => s === currentFormatValue);

    if (currentSeparator && currentValue !== currentFormatValue) {
      updatedString = updatedString.slice(0, i) + currentSeparator + updatedString.slice(i);
    }
  }
  const nextChar = format.charAt(updatedString.length);

  const nextCharRegex = /[x\d]/;
  if (!nextCharRegex.exec(nextChar)) {
    return updatedString + nextChar;
  }
  return updatedString;
}

export const formatPhone = (phoneNumber?: string, noSpaces?: boolean) => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  const input = phoneNumber.replace(/\D/g, '').replace(/^1/, '');
  const areaCode = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, phoneNumber.length);
  if (input.length > 6) {
    return noSpaces ? `(${areaCode}) ${middle}-${last}` : `(${areaCode}) ${middle} - ${last}`;
  } else if (input.length > 3) {
    return `(${areaCode}) ${middle}`;
  } else if (input.length > 0) {
    return `(${areaCode}`;
  }
};
